import { FC, useEffect } from 'react';
import { useSelector } from 'react-redux';

import { selectAdfoxYMEvents } from 'shared/store/adfoxParams/selectors/selectAdfoxYMEvents';

type YMEventsCenterProps = {
  ymCounterId: number;
};

/**
 * @description Центр отправки событий в Яндекс.Метрику
 */
export const YMEventsCenter: FC<YMEventsCenterProps> = props => {
  const { ymCounterId } = props;

  const ymEvents = useSelector(selectAdfoxYMEvents);
  const ymPriceChangeEventData = ymEvents?.onPriceChange;

  useEffect(() => {
    if (ymPriceChangeEventData && ym) {
      ym(ymCounterId, ymPriceChangeEventData.eventName, ymPriceChangeEventData.target);
    }
  }, [ymCounterId, ymPriceChangeEventData]);

  return null;
};
